/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const CertificationPage = lazyLoad(
  () => import('./index'),
  module => module.CertificationPage
);
